import { render, staticRenderFns } from "./africaLabel.vue?vue&type=template&id=8723dc0e&scoped=true&"
import script from "./africaLabel.vue?vue&type=script&lang=js&"
export * from "./africaLabel.vue?vue&type=script&lang=js&"
import style0 from "./africaLabel.vue?vue&type=style&index=0&id=8723dc0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8723dc0e",
  null
  
)

export default component.exports